<!--
 * @Author: zsh
 * @Date: 2020-06-23 10:06:43
 * @LastEditors: zsh
 * @LastEditTime: 2020-07-08 00:03:07
 * @FilePath: /official-website/src/components/Footer.vue
 -->
<template>
  <div id="footer" class="container-fluid">
    <img class="footer-bg" src="@/assets/img/footer_bg.png" alt="" />
    <!-- 联系我们 -->
    <div class="footer-company container-fuild">
      <div class="company-left">
        <div class="company-left-tit">{{ footer.company }}</div>
        <div class="company-left-item">{{ footer.tel }}</div>
        <div class="company-left-item">
          {{ footer.email }}
        </div>
        <div class="company-left-item">
          {{ footer.address }}
        </div>
        <div class="company-left-icon">
          {{ footer.attention_title }}
          <a :href="footer.facebook">
            <img :src="footer.facebook_image" alt="" />
          </a>
          <a :href="footer.instagram">
            <img :src="footer.instagram_image" alt="" />
          </a>
          <a :href="footer.twitter">
            <img :src="footer.twitter_image" alt="" />
          </a>
          <a :href="footer.codeimage">
            <img :src="footer.codeimage_image" alt="" />
          </a>
        </div>
      </div>
      <div class="company-right">
        <div class="company-right-tit">
          {{ language == "zh" ? "在线留言" : "DO YOU HAVE ANY QUESTIONS?" }}
        </div>
        <div class="company-right-text">
          {{
            language == "zh"
              ? "如果有任何问题请在这里联系我们"
              : "Please reach out to us if you have any questions"
          }}
        </div>
        <div @click="handleShowModel" class="company-right-button">
          {{ language == "zh" ? "联系我们" : "CONTACT US" }}
        </div>
      </div>
    </div>
    <div class="footer-c">
      <img class="footer-c-bg" src="@/assets/img/logo_bg.png" alt="logo背景" />
      <div class="footer-c-logo">
        <img :src="footer.logo || '@/assets/img/logo_white.png'" alt="logo图" />
      </div>
      <div v-if="footer.menu && footer.menu.length > 0" class="footer-c-list">
        <div
          v-for="(item, index) in footer.menu"
          :key="index + 'a'"
          v-show="index > 0"
          class="list-item"
        >
          <div
            @click="goItem(item.path, index)"
            :class="language == 'en' ? 'font-en' : ''"
            class="list-item-title"
          >
            {{ item.title }}
          </div>
          <ul v-if="index > 0 && item.c_menu && item.c_menu.length > 0">
            <li
              v-for="(cItem, cIndex) in item.c_menu"
              :key="cIndex"
              @click="goItem(item.path, index, cIndex + '')"
              :class="language == 'en' ? 'font-en' : ''"
            >
              {{ cItem.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-b">{{ footer.beian }}</div>

    <div v-if="footerShowModel" class="footer-model">
      <img class="model-bg" src="@/assets/img/logo_bg2.png" alt="">
      <div @click="handleCloseModel" class="close-model">
        <img src="@/assets/img/icon_close.png" alt="" />
      </div>
      <div class="model-title">
        {{ language == "zh" ? "在线留言" : "ONLINE MESSAGE" }}
      </div>
      <div class="model-form">
        <div class="form-item">
          <label class="form-item-label" for="submit-name">{{
            language == "zh" ? "姓名" : "FIRST NAME"
          }}</label>
          <input id="submit-name" v-model="formSubmit.name" type="text" />
        </div>
        <div v-if="language == 'en'" class="form-item">
          <label class="form-item-label" for="submit-enname">LAST NAME</label>
          <input id="submit-enname" v-model="formSubmit.enname" type="text" />
        </div>
        <div class="form-item">
          <label class="form-item-label" for="submit-area">{{
            language == "zh" ? "国家/地区" : "COUNTRY"
          }}</label>
          <input id="submit-area" v-model="formSubmit.area" type="text" />
        </div>
        <div class="form-item">
          <label class="form-item-label" for="submit-email">{{
            language == "zh" ? "邮箱" : "EMAIL"
          }}</label>
          <input id="submit-email" v-model="formSubmit.email" type="text" />
        </div>
        <div class="form-item">
          <label class="form-item-label" for="submit-phone">{{
            language == "zh" ? "电话" : "PHONE"
          }}</label>
          <input id="submit-phone" v-model="formSubmit.phone" type="phone" />
        </div>
        <div class="form-item">
          <label class="form-item-label" for="submit-industry">{{
            language == "zh" ? "行业" : "INDUSTRY"
          }}</label>
          <input
            id="submit-industry"
            v-model="formSubmit.industry"
            type="text"
          />
        </div>
        <div class="form-item">
          <label class="form-item-label" for="submit-remarks">{{
            language == "zh" ? "需求备注" : "COMMENTS"
          }}</label>
          <input id="submit-remarks" v-model="formSubmit.remarks" type="text" />
        </div>
      </div>
      <div @click="submit" class="model-button">
        {{ language == "zh" ? "提交" : "SUBMIT" }}
      </div>
    </div>
    <div v-if="message" class="submit-msg">{{ message }}</div>
  </div>
</template>
<script>
import VDistpicker from "v-distpicker";
export default {
  name: "Footer",
  inject: ["reload"],
  components: { VDistpicker },
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      footer: {},
      footerShowModel: false,
      formSubmit: {
        name: "",
        enname: "",
        area: "",
        email: "",
        phone: "",
        industry: "",
        remarks: ""
      },
      message: ""
    };
  },
  beforeMount() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      this.$post(this.$api.footer).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.footer = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    goItem(path, index, cIndex) {
      if (cIndex) {
        switch (path) {
          case "/product":
            sessionStorage.setItem("productIndex", cIndex);
            break;
          case "/program":
            sessionStorage.setItem("programIndex", cIndex);
            break;
          case "/case":
            sessionStorage.setItem("caseIndex", Number(cIndex) + 1 + "");
            break;
          case "/news":
            sessionStorage.setItem("newsIndex", Number(cIndex) + 1 + "");
            break;
          case "/about":
            sessionStorage.setItem("aboutIndex", Number(cIndex) + 1 + "");
            break;
        }
      } else if (path == '/about') {
        sessionStorage.setItem("aboutIndex", 0);
      }
      if (this.$route.path === path) {
        this.reload();
      } else {
        this.$router.push({ path });
      }
      sessionStorage.setItem("navIndex", index);
      this.$emit("navigatorTo", index);
      window.scrollTo(0, 0);
    },
    handleShowModel() {
      this.footerShowModel = true;
    },
    handleCloseModel() {
      this.footerShowModel = false;
      this.formSubmit = {
        name: "",
        enname: "",
        area: "",
        email: "",
        phone: "",
        industry: "",
        remarks: ""
      };
    },
    // 提交
    submit() {
      console.log(this.formSubmit);
      const _this = this;
      _this.$post(_this.$api.submit, _this.formSubmit).then(res => {
        console.log(res);
        if (res.code == 1) {
          _this.message = res.msg;
          _this.handleCloseModel();
        } else {
          console.log(res.msg);
          _this.message = res.msg;
        }
      });
      _this.closeMessage();
    },
    closeMessage() {
      const _this = this;
      setTimeout(() => {
        _this.message = "";
      }, 2000);
    }
  }
};
</script>
<style lang="scss" scoped>
#footer {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: #f8f8f8;
  overflow: hidden;
  .footer-bg {
    position: absolute;
    top: 234px;
    right: 0;
  }
  .footer-company {
    position: relative;
    display: flex;
    width: 100%;
    max-width: 1610px;
    transition: all ease 0.6s;
    padding: 100px 0 80px;
    margin: 0 auto;
    .company-left {
      width: 50%;
      padding-left: 30px;
      .company-left-tit {
        font-size: 24px;
        columns: #4b4b4b;
        margin-bottom: 40px;
      }
      .company-left-item {
        font-size: 18px;
        color: #919191;
        line-height: 1.8;
      }
      .company-left-icon {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #919191;
        margin-top: 20px;
        img {
          // 2f70a7
          width: 61px;
          height: 61px;
          margin-left: 20px;
        }
      }
    }
    .company-right {
      width: 50%;
      padding-left: 110px;

      .company-right-tit {
        font-size: 24px;
        columns: #4b4b4b;
        margin-bottom: 40px;
      }
      .company-right-text {
        font-size: 18px;
        color: #919191;
        line-height: 1.8;
      }
      .company-right-button {
        width: 370px;
        height: 100px;
        line-height: 100px;
        font-size: 24px;
        color: #28282b;
        text-align: center;
        border: 2px solid #292929;
        cursor: pointer;
        margin-top: 40px;
      }
    }
  }
  .footer-c {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 480px;
    color: #fff;
    background: #2f70a7;
    padding: 40px 120px 40px 240px;
    .footer-c-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 400px;
    }
    .footer-c-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 100%;
      z-index: 1;
      margin-right: 150px;
      img {
        width: 200px;
        height: 256px;
      }
    }
    .footer-c-list {
      flex: 1;
      display: flex;
      width: 0;
      z-index: 1;
      .list-item {
        margin-right: 50px;
        .list-item-title {
          font-size: 24px;
          // font-weight: 500;
          margin-bottom: 30px;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
          &.font-en {
            font-size: 20px;
          }
        }
        ul {
          li {
            line-height: 1.6;
            font-size: 18px;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
            &.font-en {
              font-size: 18px;
            }
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .footer-b {
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 18px;
    color: #4b4b4b;
    text-align: center;
  }
  .footer-model {
    position: fixed;
    bottom: 0;
    right: 20px;
    // width: 45%;
    // height: 90%;
    width: 580px;
    height: 770px;
    background-color: #fff;
    // border: 4px solid #1d559a;
    padding: 60px 80px 60px;
    z-index: 999;
    .model-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    .close-model {
      position: absolute;
      top: 0;
      right: 20px;
      width: 60px;
      height: 60px;
      padding: 15px;
      z-index: 1;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .model-title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
      line-height: 60px;
      font-size: 24px;
      text-align: center;
      color: #fff;
      background-color: #2f70a7;
    }
    .model-form {
      padding: 50px 0;
      .form-item {
        display: flex;
        align-items: center;
        width: 100%;
        height: 60px;
        font-size: 18px;
        border-bottom: 1px solid #2f70a7;
        label {
          margin-bottom: 0 !important;
        }
        .form-item-label {
          width: 120px;
          // height: 100%;
          // line-height: 60px;
          text-align: justify;
          text-align-last: justify;
          font-weight: 400;
          color: #2f70a7;
          padding-top: 10px;
          // margin-right: 20px;
        }
        input {
          flex: 1;
          width: 0;
          height: 100%;
          font-size: 28px;
          color: #2f70a7;
          padding: 10px 20px 0;
        }
      }
    }
    .model-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 248px;
      height: 64px;
      font-size: 20px;
      color: #2f70a7;
      border: 1px solid #2f70a7;
      cursor: pointer;
      margin: 0 auto;
    }
  }
  .submit-msg {
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 200px;
    font-size: 30px;
    text-align: center;
    color: #fff;
    background: rgba($color: #000000, $alpha: 0.8);
    border-radius: 20px;
    padding: 20px 30px;
    transform: translate(-50%, -50%);
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue